import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import { debounce } from "lodash";
import {
  organizationService,
  contentsExportService,
  importContentsService,
  serviceFatcory,
  checkContentBeforeDeleteService,
  contentlistService,
  contentsService,
  publicContentsService,
  contentService,
  bulkUpdateService,
  contentCopyService,
  contentBulkService,
  decodeContentService,
  contentInitiativeService,
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";
import moment from "moment";

const initialState = {
  currentPathValue: "1",
  showLandingPageFlag: true,
  categoryList: [],
  categoriesArr: [],
  subCategoriesArr: [],
  addContentBreadCrum: false,
  contentList: [],
  contentListData: {},
  contentListDataforCSV: [],
  selectedMultipleIds: [],
  activePage: 1,
  editContent: {},
  editContentPage: false,
  reviewerList: [],
  contentsToReview: [],
  contentStatus: "",
  authorizeContent: false,
  contentSearchOn: false,
  searchQuery: {},
  inDevelopmentArr: [],
  publishedArr: [],
  under_reviewArr: [],
  reviewByMeArr: 0,
  contentsToExport: [],
  searchedCategory: "",
  reviewRequestArr: 0,
  contentCountData: {},
  isContentImported: false,
  allContentsByUserIdAndTeamId: [],
  splitAtSize: null,
  resourcePaneFlag: null,
  selectedContent: {},
  decodedContents: null,
  treeNode: "",
  baseTableQuery:{},
  contentLoading:false,
  contentComponentMounted:false,
  treeNodeSelected:false,
  selectedTreeId:9,
  cancelFlag:false,
};

export default {
  state: initialState,
  reducers: {
    setTreeNode(state, payload) {
      return {
        ...state,
        treeNode: payload,
      };
    },
    setCancelFlag(state,payload){
      return {
        ...state,
        cancelFlag: payload,
      };
    },
    setTreeNodeSelected(state,payload){
      return {
        ...state,
        treeNodeSelected: payload,
      }
    },
    setSelectedTreeId(state, payload) {
      return {
        ...state,
        selectedTreeId: payload,
      }
    },
    setTreeCurrentPath(state, payload) {
      return {
        ...state,
        currentPathValue: payload,
      };
    },
    setLandingPageFlag(state, payload) {
      return {
        ...state,
        showLandingPageFlag: payload,
      };
    },
    setContentLoading(state,payload){
      return {
        ...state,
        contentLoading:payload,
      }
    },
    setContentList(state, payload) {
      return {
        ...state,
        contentList: payload,
      };
    },

    setContentComponentMounted(state,payload){
      return {
        ...state,
        contentComponentMounted: payload,
      }
    },
    setContentListData(state, payload) {
      return {
        ...state,
        contentListData: payload,
      };
    },
    setContentListDataforCSV(state, payload) {
      return {
        ...state,
        contentListDataforCSV: payload,
      };
    },
    setMultipleIds(state, payload) {
      return {
        ...state,
        selectedMultipleIds: payload,
      };
    },
    setBasecategory(state, payload) {
      return {
        ...state,
        categoryList: payload,
      };
    },

    setCategory(state, payload = []) {
      return {
        ...state,
        categoriesArr: payload,
      };
    },
    setSubCategory(state, payload = []) {
      return {
        ...state,
        subCategoriesArr: payload,
      };
    },
    setActivePage(state, payload) {
      return {
        ...state,
        activePage: payload,
      };
    },
    setAddContentBreadCrum(state, payload) {
      return {
        ...state,
        addContentBreadCrum: payload,
      };
    },
    setEditContent(state, payload) {
      return {
        ...state,
        editContent: payload,
      };
    },
    setEditContentPage(state, payload) {
      return {
        ...state,
        editContentPage: payload,
      };
    },
    setReviewerList(state, payload) {
      return {
        ...state,
        reviewerList: payload,
      };
    },
    setcontentsToReview(state, payload) {
      return {
        ...state,
        contentsToReview: payload,
      };
    },
    setContentStatus(state, payload) {
      return {
        ...state,
        contentStatus: payload,
      };
    },
    setAuthorizeBreadcrum(state, payload) {
      return {
        ...state,
        authorizeContent: payload,
      };
    },
    clear(state, payload) {
      if (payload) {
        return initialState;
      } else {
        return {
          ...initialState,
          selectedBaseCategory: state.selectedBaseCategory,
          selectedCategory: state.selectedCategory,
          selectedSubCategory: state.selectedSubCategory,
        };
      }
    },
    setContentSearchOn(state, payload) {
      return {
        ...state,
        contentSearchOn: payload,
      };
    },
    setSearchQuery(state, payload) {
      return {
        ...state,
        searchQuery: payload,
      };
    },
    setInDevelopmentList(state, payload) {
      return {
        ...state,
        inDevelopmentArr: payload,
      };
    },
    setpublishedList(state, payload) {
      return {
        ...state,
        publishedArr: payload,
      };
    },
    setunder_reviewList(state, payload) {
      return {
        ...state,
        under_reviewArr: payload,
      };
    },
    setreviewByMeArrList(state, payload) {
      return {
        ...state,
        reviewByMeArr: payload,
      };
    },
    getContentsDataToExport(state, payload = []) {
      return {
        ...state,
        contentsToExport: payload,
      };
    },
    setCategoryKnowledgeBank(state, payload) {
      return {
        ...state,
        searchedCategory: payload,
      };
    },
    setreviewRequestArrList(state, payload) {
      return {
        ...state,
        reviewRequestArr: payload,
      };
    },
    setContentCountsData(state, payload) {
      return {
        ...state,
        contentCountData: payload,
      };
    },
    setIsContentImported(state, payload) {
      return {
        ...state,
        isContentImported: payload,
      };
    },
    setContentsByUserIdAndTeamId(state, payload) {
      return {
        ...state,
        allContentsByUserIdAndTeamId: payload,
      };
    },
    setSplitAtSize(state, payload) {
      return {
        ...state,
        splitAtSize: payload,
      };
    },
    showResourecePaneFlagSet(state, payload) {
      return {
        ...state,
        resourcePaneFlag: payload,
      };
    },
    setSelectedContent(state, payload) {
      return {
        ...state,
        selectedContent: payload,
      };
    },
    setDecodedContent(state, payload) {
      return {
        ...state,
        decodedContents: payload,
      };
    },
    setBaseTableQuery(state,payload){
      return {
        ...state,
        baseTableQuery: payload,
      };
    }

  },
  effects: {
    async addNewContent(payload, state) {
      let htmlString = payload.description;
      var regex = /<a\s+[^>]*href\s*=\s*["']?([^"'>\s]*)["']?[^>]*>/gi;
      var modifiedHtml = htmlString.replace(regex, function (match, href) {
        // Check if the href starts with either http:// or https://
        if (!/^https?:\/\//i.test(href)) {
          // If not, add https:// before www
          href = href.replace(/^(www\..*)/i, "https://$1");
        }
        return `<a href="${href}">`;
      });
      payload.description = modifiedHtml;
      try {
        payload.name = payload.name.trim();
        const addedContent = await contentService.create(payload);
        if (addedContent.subCategoryCreated) {
          dispatch.app.setSelectedSubCategory(addedContent.subCategoryCreated);
        }

        if (payload.status === "published") {
          toastr.success(
            "Message",
            payload.name + " content added and published successfully"
          );
        } else  if(payload.reviewedby){
          toastr.success(
            "Message",
            payload.name + " content is successfully submitted for review"
          );
        }
        else{
          toastr.success(
            "Message",
            payload.name + " content added successfully"
          );
        }
        let userid = payload.author.toString();
        let payloadObj = {};
        payloadObj.organizationId = payload.organizationId;
        payloadObj.accountId = payload.accountId;
        payloadObj.userid = userid;
        // await dispatch.content.getAllContents(payloadObj);
        // await dispatch.content.setCategory([]);
        // await dispatch.content.setSubCategory([]);
        // await dispatch.content.getContentsCount({ organizationId: payload.organizationId, accountId: payload.accountId, 'value': 'All' })
        if (document.getElementById("addcontentForm")) {
          document.getElementById("addcontentForm").reset();
        }
        dispatch.content.getCategoryAsync({
          organizationId: payload.organizationId,
          accountId: payload.accountId,
        });
        dispatch.content.getContentsCount({
          organizationId: payload.organizationId,
          accountId: payload.accountId,
          value: "All",
        });
        if (state.content.treeNode === "") {
          return dispatch(
            push(
              state.app.contentPath
                ? `/app/${payload.accountId}/_ws/${
                    payload.organizationId
                  }/_ct/${state.app.contentPath.split("_ct/")[1]}`
                : `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/status/in_development`
            )
          );
        } else {
          return dispatch(
            push(
              state.app.contentPath
                ? `/app/${payload.accountId}/_ws/${
                    payload.organizationId
                  }/_ct/${state.app.contentPath.split("_ct/")[1]}`
                : `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/status/${state.content.treeNode}`
            )
          );
        }
      } catch (err) {
        throw err;
      }
    },
    async updateContents(editContent, state) {
      let contentId = editContent.id;
      editContent.name = editContent.name.trim();
      //editContent.reviewedby = state.app.user._id
      delete editContent.id;
      try {
        let content = await contentService.patch(contentId, editContent, {
          query: {
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        });
        if (editContent.status === "published") {
          toastr.success(
            "Message",
            editContent.name + " content published successfully"
          );
        } else if (editContent.status === "rejected") {
          toastr.success(
            "Message",
            editContent.name + " content rejected successfully"
          );
        } else if (editContent.status === "under_review") {
          toastr.success(
            "Message",
            editContent.name + " content is successfully submitted for review"
          );
        }
          else if (editContent.status === "approved") {
            toastr.success(
              "Message",
              editContent.name + " content is successfully approved"
            );
          
        } else {
          toastr.success(
            "Message",
            editContent.name + " content updated successfully"
          );
        }
        let payload = {};
        payload.organizationId = editContent.organizationId;
        payload.accountId = editContent.accountId;
        payload.userid = editContent.userid;

        dispatch.content.getContentsCount({
          organizationId: editContent.organizationId,
          accountId: editContent.accountId,
          value: "All",
        });
        dispatch.content.getCategoryAsync({
          organizationId: editContent.organizationId,
          accountId: editContent.accountId,
        });
        return dispatch(
          push(
            state.app.contentPath
              ? `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/${
                  state.app.contentPath.split("_ct/")[1]
                }`
              : `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/status/${editContent.currentContentStatus}`
          )
        );
      } catch (err) {
        if (err.code === 409) {
          toastr.error("Message", `${editContent.name} already exists`);
        } else {
          toastr.error("Message", "Validations Failed! Please check the form.");
        }
        throw err;
      }
    },
    async publishedBulkContent(payload, state) {
      try {
        let result;
        if (payload.dataType === "updateCategory") {
          result = await contentBulkService.create({
            contentIds: payload.idArray,
            updateData: {
              baseCategory: payload.baseCategory,
              category: payload.category,
              subCategory: payload.subCategory,
            },
            organizationId: state.app.selectedOrganisation.id,
            accountId: state.app.selectedAccount._id,
          });
          toastr.success(
            "Message",
            payload.idArray.length + " content category updated successfully"
          );
        }

        if (payload.dataType === "publishAll") {
          result = await contentBulkService.create({
            contentIds: payload.idArray,
            updateData: { status: "published" },
            organizationId: state.app.selectedOrganisation.id,
            accountId: state.app.selectedAccount._id,
          });
          toastr.success(
            "Message",
            payload.idArray.length + " content published successfully"
          );
        }
      } catch (e) {
        throw e;
      }
    },
    async deleteBulkContent(payload, state) {
      try {
        let data={}
        data.payload = {
          deleted: true,
          deletedAt: new Date(),
        };
        data.idArray=payload.idArray        
        data.entity='content'
        data.organizationId = state.app.selectedOrganisation.id;
        data.accountId = state.app.selectedAccount._id;
        let response = await bulkUpdateService.create(data)
        toastr.success(
          "Message",
          response.n + " contents deleted successfully"
        );
      } catch (err) {
        toastr.error("Message", err.message);
        throw err;
      }
    },
    async copyContent(payload) {
      try {
        await contentCopyService.create(payload);
        toastr.success(
          "Message",
          `Content ${payload.name} copied successfully !`
        );
      } catch (err) {
        throw err;
      }
    },
    async updateCategoryContents(payload) {
      try {
        await contentService.patch(payload._id, payload.data);
      } catch (err) {}
    },
    async updateContentInSelectedPlaybook(payload, state) {
      try {
        if (
          state.app.selectedOrganisation &&
          state.app.selectedOrganisation.id &&
          state.app.selectedOrganisation.id.toString() ===
            payload.organizationId.toString()
        ) {
          dispatch.content.setSelectedContent(payload);
          let activitySummaryData = state.lifeCycle.activitySummary;
          if (activitySummaryData.references) {
            for (let i = 0; i < activitySummaryData.references.length; i++) {
              for (let [index, content] of activitySummaryData.references[
                i
              ].references.entries()) {
                if (content.id._id.toString() === payload._id.toString()) {
                  activitySummaryData.references[i].references[index].id.scope =
                    Object.assign({}, content.scope, payload.scope);
                }
              }
            }
          }
        }
      } catch (err) {}
    },

    async isContentAvailable(payload, state) {
      try {
        const getContent = await contentService.get(payload.id);
        await dispatch(
          push(
            "/app/" +
              state.app.selectedAccount._id +
              "/_ws/" +
              state.app.selectedOrganisation.id +
              "/_ct/details/" +
              payload.id
          )
        );
        dispatch.content.setEditContent(getContent);
      } catch (e) {
        if (state.home.redirectFromDashboard) {
          dispatch.home.eventDetailsNotFound(true);
        }
      }
    },
    async getSpecificContent(payload, state) {
      try {
        let getContent;
        try {
          if (payload.populate) {
            getContent = await contentService.get(payload.contentId, {
              query: {
                $populate: [
                  {
                    path: "author",
                    populate: "author",
                    select: "_id firstName lastName profilePic email",
                  },
                  {
                    path: "baseCategory",
                    populate: "baseCategory",
                    select: "_id name",
                  },
                  {
                    path: "category",
                    populate: "category",
                    select: "_id name",
                  },
                  {
                    path: "subCategory",
                    populate: "subCategory",
                    select: "_id name",
                  },
                ],
              },
            });
          } else {
            getContent = await contentService.get(payload.contentId);
          }
        } catch (e) {
          throw e;
        }

        await dispatch.content.setEditContent(getContent);
      } catch (err) {
        if (err.code === 409) {
          toastr.error("Message", `${payload.name} already exists`);
        } else {
          return dispatch(push(`/app/${state.app.selectedAccount._id}/404`));
        }
        throw err;
      }
    },
    // is called on content page
    getContentListData: async function (payload, state) {
      if(!state.content.contentLoading){
      dispatch.content.setContentLoading(true);
      if(payload.query.$limit < 101){
        dispatch.content.setContentListData({data:[],total:0})
      }
      let query = {
        $and: [],
        $limit: payload.query.$limit,
        $skip: payload.query.$skip,
        $sort: payload.query.$sort,
        currentUserrRole: payload.currentUser ? payload.currentUser.role : null,
        currentUsersId: payload.currentUser
          ? payload.currentUser.accountUserId
          : null,
      };
      if (payload.params.status) {
     if (payload.params.status === "reviewRequest") {
       // Show content sent for review (author's perspective)
       query.$and.push({ 
         status: "under_review",
         author: state.app.user._id 
       });
     } else if (payload.params.status === "forReview") {
       // Show content received for review (reviewer's perspective)
       query.$and.push({ 
         status: "under_review",
         reviewedby: state.app.user._id
       });
     }  
     else if (payload.params.status === "approved") {
       // Special handling for approved content
       query.$and.push({ 
         status: "approved",
         author: state.app.user._id  // Only show approved content where user is author
       });
     } 
     else if (payload.params.status !== "knowledgeBank" && 
                payload.params.status !== "publicKnowledgeBank" && 
                payload.params.status !== "contentLibrary") {
       query.$and.push({ status: payload.params.status });
     }
   }
      if (payload.query.$and) {
        query.$and = payload.query.$and;
      }

      if (payload.query.createdAt) {
        query.createdAt = payload.query.createdAt;
      }

      if (payload.query.scope) {
        query.$and.push({
          scope: payload.query.scope,
        });
      } else if (
        payload.params.status &&
        payload.params.status === "knowledgeBank"
      ) {
        query.$and.push({
          scope: "Private",
        });
      }

      if (
        payload.params.status &&
        payload.params.status !== "knowledgeBank" &&
        payload.params.status !== "publicKnowledgeBank" &&
        payload.params.status !== "contentLibrary"
      ) {
        query.$and.push({ status: payload.params.status });
      }
      if (
        payload.params.status &&
        (payload.params.status === "knowledgeBank" ||
          payload.params.status === "publicKnowledgeBank")
      ) {
        let obj = {};
        if (state.app.selectedOrganisation.role !== "workspaceOwner") {
          obj.$or = [
            { status: "published" },
            { createdBy: state.app.user._id },
          ];
        }
        if (payload.query.scope !== "Public") {
          obj.isKnowledgeBank = true;
          obj.scope = payload.query.scope;
        }
        query.$and.push(obj);
      }
      if (payload.params.baseCategory) {
        query.$and.push({ baseCategory: payload.params.baseCategory });
      }
      if (payload.params.category) {
        query.$and.push({ category: payload.params.category });
      }
      if (payload.params.subCategory) {
        if (
          payload.params.subCategory === "Others" &&
          payload.query.subCategoryArr
        ) {
          query.$and.push({
            subCategory: { $nin: payload.query.subCategoryArr },
          });
        } else {
          query.$and.push({ subCategory: payload.params.subCategory });
        }
      }
      // same condition write in bulkOperationIds function to get same data
      if (payload.params.dataType && payload.params.dataType !="deleteAll") {
        let obj = {
          $or: [],
        };
        obj.$or.push({ status: "in_development" });
        if (payload.params.dataType === "updateCategory") {
          obj.$or.push({ status: "published" });
          obj.$or.push({ status: "rejected" });
          obj.$or.push({ status: "approved" });
          query.$and.push({ scope: "Private" });
        }
        if (state.app.selectedOrganisation.role !== "workspaceOwner") {
          query.$and.push({ createdBy: state.app.user._id });
        }
        query.$and.push(obj);
        query.$and.push({ baseCategory: { $exists: true } });
      }
      let contents;
      query.deleted = { $exists: false };
      query.sanitizeBooleanFields = true;
      if(query.$and && query.$and.length === 0){
        delete query.$and
      }
      if(!query.organizationId){
        query.organizationId = payload.params.workspaceId;
      }
      try{
      if (!payload.query.scope || payload.query.scope === "Private") {
        contents = await contentlistService.find({ query: query });
      } else if (payload.query.scope === "Public") {
        contents = await contentlistService.find({ query: query });
      }
      for (let i = 0; i < contents.data.length; i++) {
        contents.data[i].authorfirstName = contents.data[i].authorObj.firstName;
        contents.data[i].authorlastName = contents.data[i].authorObj.lastName;
        contents.data[i].profilePic = contents.data[i].authorObj.profilePic;
        // contents.data[i].baseCategoryName = contents.data[i].baseCategory.name;
        // contents.data[i].categoryName = contents.data[i].category.name;
        // contents.data[i].subCategoryName = contents.data[i].subCategory.name;
        if (contents.data[i].status === "in_development") {
          contents.data[i].updatedStatus = "In Design";
        } else if (contents.data[i].status === "published") {
          contents.data[i].updatedStatus = "Published";
        } else if (contents.data[i].status === "under_review") {
          contents.data[i].updatedStatus = "Review request";
        } else if (contents.data[i].status === "forreview") {
          contents.data[i].updatedStatus = "Sent";
        } else if (contents.data[i].status === "reviewRequest") {
          contents.data[i].updatedStatus = "Received";
        } else if (contents.data[i].status === "knowledgebank") {
          contents.data[i].updatedStatus = "Knowledge Bank";
        } else if (contents.data[i].status === "approved") {
          contents.data[i].updatedStatus = "Approved";
        } else if (contents.data[i].status === "rejected") {
          contents.data[i].updatedStatus = "Rejected";
        } else {
          contents.data[i].updatedStatus = contents.data[i].status;
        }
      }
        if(payload.query && payload.query.$and && payload.query.$and.length === 0){
          delete payload.query.$and
        }
      if (payload.query.$limit < 101) {
        await dispatch.content.setContentListData(contents);
        dispatch.content.setContentLoading(false);
      } else {
        let downloadSpecificData = [];
        // let markMultiIds = []
        if (contents && contents.data && contents.data.length !== 0) {
          for (let i = 0; i < contents.data.length; i++) {
            contents.data[i].authorfirstName =
              contents.data[i].authorObj.firstName;
            contents.data[i].authorlastName =
              contents.data[i].authorObj.lastName;

            let status =
              contents.data[i].status === "in_development"
                ? "In Design"
                : contents.data[i].status === "published"
                ? "Published"
                : contents.data[i].status === "under_review"
                ? "Review request"
                : contents.data[i].status === "forreview"
                ? "Received"
                : contents.data[i].status === "reviewRequest"
                ? "Sent"
                : contents.data[i].status === "knowledgebank"
                ? "Knowledge Bank"
                : contents.data[i].status === "approved"
                ? "Approved"
                : contents.data[i].status;

            downloadSpecificData.push({
              Name: contents.data[i].name.replace(",", " "),
              Status: status,
              Type: contents.data[i].type,
              KnowledgeBank: contents.data[i].baseCategory,
              Category: contents.data[i].category,
              SubCategory: contents.data[i].subCategory,
              CreatedDate: moment(contents.data[i].createdAt).format(
                "MMMM DD YYYY h:mm:ss a"
              ),
              Description: contents.data[i].description
                ? contents.data[i].description.replace(/(<([^>]+)>)/gi, "")
                : "",
              ContentAuthor: contents.data[i].contentAuthor,
              ContentURL: contents.data[i].contentpath,
              // UploadedBy: contents.data[i].authorObj.firstName + " " + contents.data[i].authorObj.lastName
              // below change is made for KLM-8935
              Creator:
                contents.data[i].authorObj.firstName +
                " " +
                contents.data[i].authorObj.lastName,
            });
            // markMultiIds.push(contents.data[i]);
          }
        } else {
          downloadSpecificData.push({
            NoDataAvailable: "Nothing to show ...!",
          });
        }
        await dispatch.content.setContentListDataforCSV(downloadSpecificData);
        dispatch.content.setContentLoading(false);
      }
     }catch(e){
      console.error(e);
      dispatch.content.setContentLoading(false);
     }
     }
    },

    async bulkOperationIds(payload, state) {
      let query = {
        $and: [],
        $limit: 10000,
        $skip: 0,
        $sort: { createdAt: -1 },
      };
      if (payload.query.$and) {
        query.$and = payload.query.$and;
      }
      // same conndition in getContentListData function to set exact data
      if (payload.params.dataType && payload.params.dataType !="deleteAll") {
        let obj = {
          $or: [],
        };
        obj.$or.push({ status: "in_development" });

        if (payload.params.dataType === "updateCategory") {
          obj.$or.push({ status: "published" });
          obj.$or.push({ status: "rejected" });
          obj.$or.push({ status: "approved" });
          query.$and.push({ scope: "Private" });
        }

        if (state.app.selectedOrganisation.role !== "workspaceOwner") {
          query.$and.push({ createdBy: state.app.user._id });
        }

        query.$and.push(obj);
      //  query.$and.push({ baseCategory: { $exists: true } });
      }
      if(query.$and && query.$and.length === 0){
        delete query.$and
      }
      query.deleted = {"$exists": false};
      let contents = await contentsService.find({ query: query });

      //let getIds = _.map(contents.data, "_id")
      await dispatch.content.setMultipleIds(contents.data);
    },
    showLandingPage(payload) {
      dispatch.content.setLandingPageFlag(payload);
    },
    async getCategoryAsync(payload) {
      try {
        await dispatch.lifeCycle.getCategoryTreeAsync(payload);
      } catch (err) {
        throw err;
      }
    },

    setCategoryAsync(payload) {
      dispatch.content.setCategory(payload);
    },
    setSubCategoryAsync(payload) {
      dispatch.content.setSubCategory(payload);
    },
    showAddContentBreadCrum(payload) {
      dispatch.content.setAddContentBreadCrum(payload);
    },
    async getAllContents(payload) {
      let contentQuery = {};
      contentQuery.organizationId = payload.organizationId;
      contentQuery.status = payload.status;
      contentQuery.accountId = payload.accountId;

      if (payload.dataStatus) {
        contentQuery.dataStatus = payload.dataStatus;
      }
      //contentQuery.$sort = { createdAt: -1 }
      contentQuery.$sort = { slug: 1 };
      contentQuery.deleted = { $exists: false };
      const contentsList = await contentlistService.find({
        query: contentQuery,
      });

      dispatch.content.setContentList(contentsList.data);

      let reviewByMeArr = [];
      let reviewRequestArr = [];

      var contentList = contentsList.data;
      contentList.map(function (singleContent) {
        if (
          singleContent.status === "under_review" &&
          singleContent.reviewedby == payload.userid
        ) {
          reviewByMeArr.push(singleContent);
        }
        if (
          singleContent.status === "under_review" &&
          singleContent.author == payload.userid
        ) {
          reviewRequestArr.push(singleContent);
        }
      });

      dispatch.content.setreviewByMeArrList(reviewByMeArr.length);
      dispatch.content.setreviewRequestArrList(reviewRequestArr.length);
    },

    clearContent() {
      dispatch.content.setEditContent(null);
    },
    async getReviewers(payload) {
      const reviewers = await organizationService.get(payload, {
        query: {
          $select: ["users"],
          $populate: [
            {
              path: "users.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email",
            },
          ],
        },
      });
      dispatch.content.setReviewerList(reviewers.users);
    },
    async checkIsReviewer(payload) {
      let checkQuery = {
        reviewedby: payload,
        status: "under_review",
      };
      const contentsToReview = await contentService.find({
        headers: { searchContents: true },
        query: checkQuery,
      });
      dispatch.content.setcontentsToReview(contentsToReview);
    },
    setReviewList(payload) {
      dispatch.content.setContentList(payload);
    },
    selectedContentStatus(payload) {
      dispatch.content.setContentStatus(payload);
    },
    authorizeBreadcrum(payload) {
      dispatch.content.setAuthorizeBreadcrum(payload);
    },
    // Content is deleted
    async deleteContents(payload, state) {
      try {
        // await contentService.remove(payload._id);
        let data = {
          deleted: true,
          deletedAt: new Date(),
        };
        await contentService.patch(payload._id, data, {
          query: {
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              {
                path: "category",
                populate: "category",
                select: "_id name",
              },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        });
        toastr.success(
          "Message",
          payload.name + " content deleted successfully"
        );
        await dispatch.content.getContentsCount({
          organizationId: payload.organizationId,
          accountId: payload.accountId,
          value: "All",
        });
      } catch (err) {
        toastr.error("Message", err.message);
        throw err;
      }
    },
    async getMyContenetsToExport(payload, state) {
      let query = {
        $and: [],
        createdAt: payload.query.createdAt,
        currentUserrRole: payload.currentUser.role,
        currentUsersId: payload.currentUser.accountUserId,
      };

      if (payload.query.$and) {
        query.$and = payload.query.$and;
      }

      if (payload.query.scope) {
        query.scope = payload.query.scope;
      }

      if (
        payload.params.status &&
        payload.params.status !== "knowledgeBank" &&
        payload.params.status !== "publicKnowledgeBank" &&
        payload.params.status !== "contentLibrary"
      ) {
        query.$and.push({ status: payload.params.status });
      }
      if (
        payload.params.status &&
        (payload.params.status === "knowledgeBank" ||
          payload.params.status === "publicKnowledgeBank")
      ) {
        let obj = {};
        if (state.app.selectedOrganisation.role !== "workspaceOwner") {
          // obj.status = 'published';
        }
        if (payload.query.scope !== "Public") {
          obj.isKnowledgeBank = true;
          query.$and.push({ scope: "Private" });
        }
        query.$and.push(obj);
      }
      if (payload.params.baseCategory) {
        query.$and.push({ baseCategory: payload.params.baseCategory });
      }
      if (payload.params.category) {
        query.$and.push({ category: payload.params.category });
      }
      if (payload.params.subCategory) {
        if (
          payload.params.subCategory === "Others" &&
          payload.query.subCategoryArr
        ) {
          query.$and.push({
            subCategory: { $nin: payload.query.subCategoryArr },
          });
        } else {
          query.$and.push({ subCategory: payload.params.subCategory });
        }
      }

      try {
        if (query.$and.length === 0) {
          delete query.$and;
        }
        if (payload.query.scope === "Public") {
          query.isPublicService = true;
        }
        query.deleted = { $exists: false };
        let contentsToExport = await contentsExportService.get(
          payload.organizationId,
          { query: query }
        );
        const result = await dispatch.content.getContentsDataToExport(
          contentsToExport
        );

        // return;
      } catch (e) {
        throw e;
      }
    },
    async importContents(payload, state) {
      let importedData = await importContentsService.create({ data: payload });
      //dispatch.content.getCategoryAsync(payload)

      if (importedData.failureCounter > 0) {
        toastr.warning(
          "Message",
          "Skipped " +
            importedData.failureCounter +
            " records with duplicate name"
        );
      }

      if (importedData.isFailed) {
        toastr.error("Message", "Error while importing the content.");
      }
      await dispatch.content.setIsContentImported(true);
      await dispatch.content.getContentsCount({
        organizationId: payload.organizationId,
      });
      let q = {
        query: {
          $sort: { createdAt: -1 },
          $limit: 100,
          $skip: 0,
        },
        params: {
          status: "contentLibrary",
        },
      };
      await dispatch.content.getContentListData(q);
      return dispatch(
        push(
          state.app.contentPath
            ? `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/${
                state.app.contentPath.split("_ct/")[1]
              }`
            : `/app/${payload.accountId}/_ws/${payload.organizationId}/_ct/status/contentLibrary`
        )
      );
      // return;
    },
    async getUnderReviewContents(searchQueryObj, state) {
      dispatch.content.setContentList([]);
      let searchQuery = {};
      if (searchQueryObj.name && searchQueryObj.name.length !== 0) {
        searchQueryObj.name = searchQueryObj.name.replace(".", "\\.");
        searchQuery.name = { $regex: searchQueryObj.name, $options: "i" };
      }
      if (
        searchQueryObj.type &&
        searchQueryObj.type.length !== 0 &&
        searchQueryObj.type !== "Type"
      ) {
        searchQuery.type = searchQueryObj.type;
      }
      if (
        searchQueryObj.status &&
        searchQueryObj.status.length !== 0 &&
        searchQueryObj.status !== "status"
      ) {
        searchQuery.status = searchQueryObj.status;
      }
      if (
        searchQueryObj.baseCategory &&
        searchQueryObj.baseCategory.length !== 0 &&
        searchQueryObj.baseCategory !== "baseCategory"
      ) {
        searchQuery.baseCategory = searchQueryObj.baseCategory;
      }
      if (
        searchQueryObj.uploaded_by &&
        searchQueryObj.uploaded_by.length !== 0
      ) {
        searchQuery.author = searchQueryObj.uploaded_by;
      }

      if (
        searchQueryObj.uploaded_on &&
        searchQueryObj.uploaded_on.length !== 0
      ) {
        let uploadedDate = new Date(searchQueryObj.uploaded_on);
        uploadedDate = new Date(uploadedDate.setHours(0, 0, 0, 0));
        let uploadedNextDate = new Date(uploadedDate);
        uploadedNextDate.setDate(new Date(uploadedDate.getDate() + 1));
        searchQuery.updatedAt = {
          $gte: uploadedDate,
          $lt: uploadedNextDate,
        };
      }
      if (searchQueryObj.scope && searchQueryObj.scope.length !== 0) {
        searchQuery.scope = searchQueryObj.scope;
      }
      if (searchQueryObj.reviewedby) {
        searchQuery.reviewedby = searchQueryObj.reviewedby;
      }
      if (searchQueryObj.category) {
        searchQuery.category = searchQueryObj.category;
      }
      if (searchQueryObj.organizationId) {
        searchQuery["$or"] = [
          {
            $and: [
              { scope: "Private" },
              {
                organizationId: searchQueryObj.organizationId,
                accountId: searchQueryObj.accountId,
              },
            ],
          },
          {
            $and: [
              { scope: "Public" },
              {
                organizationId: searchQueryObj.organizationId,
                accountId: searchQueryObj.accountId,
              },
            ],
          },
        ];
      }
      if (searchQueryObj.dataStatus === "reviewRequestContent") {
        delete searchQuery.reviewedby;
        delete searchQuery.status;
        if (searchQueryObj.author) {
          searchQuery["$and"] = [
            { status: "under_review" },
            { author: searchQueryObj.author },
          ];
        }
      }
      if (searchQueryObj.dataStatus === "forreviewContent") {
        if (searchQueryObj.reviewedby) {
          searchQuery.reviewedby = searchQueryObj.reviewedby;
        }
      }
      if (searchQueryObj.dataStatus === "underReviewContent") {
        delete searchQuery.reviewedby;
        searchQuery["$or"] = [
          { author: searchQueryObj.author },
          { reviewedby: searchQueryObj.reviewedby },
        ];
      }
      searchQuery["$sort"] = { updatedAt: -1 };
      searchQuery.organizationId = searchQueryObj.organizationId;
      searchQuery.accountId = searchQueryObj.accountId;

      let contents = await contentService.find({
        headers: { searchContents: true },
        query: searchQuery,
      });
      contents.data.map((singleContent) => {
        var indexContent = contents.data.indexOf(singleContent);
        if (singleContent.status === "inactive") {
          contents.data.splice(indexContent, 1);
        }
      });

      dispatch.content.setContentList(contents.data);
    },
    setSearchedQuery(payload) {
      dispatch.initiatives.setSearchQuery(payload);
    },
    setSearchedCategory(payload) {
      dispatch.content.setCategoryKnowledgeBank(payload);
    },
    // is called on content page
    async getContentsCount(payload) {
      const contentByOrgService = serviceFatcory.getProxy(
        `/organizations/contents/summary`
      );
      const contentSummary = await contentByOrgService.get(
        payload.organizationId
      );
      dispatch.content.setContentCountsData(contentSummary);
    },
    async checkContentBeforeDelete(payload) {
      try {
        await checkContentBeforeDeleteService.get(payload);
      } catch (err) {
        throw err;
      }
    },
    async getAllContentsByUserIdAndTeamId(payload) {
      let query = {
        organizationId: payload.organizationId,
        accountId: payload.accountId,
        createdBy: payload.userId,
        deleted: null,
      };
      const contents = await contentService.find({
        query: query,
      });
      dispatch.content.setAllContentsByUserIdAndTeamId(contents);
    },
    setAllContentsByUserIdAndTeamId(payload) {
      dispatch.content.setContentsByUserIdAndTeamId(payload);
    },

    splitAt(payload) {
      dispatch.content.setSplitAtSize(payload);
    },
    async openResourcePane(payload) {
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
      dispatch.content.showResourecePaneFlagSet(payload);
      // if (payload) { } else {
      //     dispatch.content.setSelectedContent({})
      // }
    },
    async setSingleContent(payload) {
      let query = {
        $populate: [
          {
            path: "author",
            populate: "author",
            select: "_id firstName lastName profilePic email",
          },
          { path: "accountId", populate: "accountId", select: "_id name logo" },
          {
            path: "organizationId",
            populate: "organizationId",
            select: "_id name",
          },
          {
            path: "baseCategory",
            populate: "baseCategory",
            select: "_id name image",
          },
          { path: "category", populate: "category", select: "_id name" },
          {
            path: "createdBy",
            populate: "createdBy",
            select: "_id firstName lastName profilePic",
          },
          { path: "subCategory", populate: "subCategory", select: "_id name" },
          {
            path: "playbookActivitiesRef.activityId",
            populate: "activityId",
            select: "_id name",
          },
          {
            path: "initiativeActivitiesRef.activityId",
            populate: "activityId",
            select: "_id name",
          },
          {
            path: "playbookActivitiesRef.playbookId",

            populate: [
              {
                path: "createdBy",
                populate: "createdBy",
                select: "_id firstName lastName profilePic email",
              },
            ],
          },
          {
            path: "initiativeActivitiesRef.initiativeId",
            select:
              "_id picture name status createdBy accountId organizationId",
            populate: [
              {
                path: "createdBy",
                populate: "createdBy",
                select: "_id firstName lastName profilePic email",
              },
            ],
          },
        ],
      };
      const singleContent = await contentService.get(payload.id, {
        query: query,
      });
      dispatch.content.setSelectedContent(singleContent);
    },
    removeContetnFromContentList(payload, state) {
      if (
        state.app.selectedOrganisation &&
        state.app.selectedOrganisation.id &&
        state.app.selectedOrganisation.id.toString() ===
          payload.organizationId.toString()
      ) {
        let contentData = state.content.contentListData;
        let contentIndex;
        if (contentData.data) {
          for (let [index, content] of contentData.data.entries()) {
            if (content._id.toString() === payload._id.toString()) {
              contentIndex = index;
              break;
            }
          }
        }
        if (!isNaN(contentIndex)) {
          contentData.data.splice(contentIndex, 1);
          dispatch.content.setContentListData(Object.assign({}, contentData));
        }
      }
    },
    async updateContentListAndSelectedContent(payload, state) {
      payload.baseCategory = payload.baseCategory.name;
      payload.category = payload.category.name;
      payload.subCategory = payload.subCategory.name;
      if (
        state.app.selectedOrganisation &&
        state.app.selectedOrganisation.id &&
        state.app.selectedOrganisation.id.toString() ===
          payload.organizationId.toString()
      ) {
        let contentData = state.content.contentListData;
        if (contentData.data && contentData.data.length > 0) {
          for (let [index, content] of contentData.data.entries()) {
            if (content._id.toString() === payload._id.toString()) {
              contentData.data[index] = Object.assign({}, content, payload);
              break;
            }
          }
        }
        if (
          payload.isPublicAccessRevoked &&
          state.content.editContent &&
          state.content.editContent._id &&
          state.content.editContent._id.toString() === payload._id.toString()
        ) {
          payload.throwOut = true;
          dispatch.content.setEditContent(Object.assign({}, payload));
        }
        dispatch.content.setContentListData(Object.assign({}, contentData));
      }
    },
    async decodeContents(payload, state) {
      let decodedContent = await decodeContentService.create({ data: payload });
      if (decodedContent.isError) {
        if (decodedContent.message === "invalidFile") {
          toastr.error("Message", "Invalid File.");
        } else {
          toastr.error("Message", "Error while importing Playbook.");
        }
      } else {
        dispatch.content.setDecodedContent(decodedContent);
      }
    },
    async contentInitiativeService(payload, state) {
      for (let i = 0; i < payload.activities.length; i++) {
        let singlePhase = payload.activities[i];
        if (singlePhase.references.length > 0) {
          for (let x = 0; x < singlePhase.references.length; x++) {
            let eachPhaseReference = singlePhase.references[x];
            let eachPhaseReferencePayload = {
              contentId: eachPhaseReference.id,
              organizationId: singlePhase.organizationId,
              initiativeId: singlePhase.initiativeId,
              activityId: singlePhase._id,
            };
            await contentInitiativeService.patch(
              eachPhaseReferencePayload,
              singlePhase
            );
          }
        }
        if (singlePhase.activities.length > 0) {
          for (let j = 0; j < singlePhase.activities.length; j++) {
            let eachStage = singlePhase.activities[j];
            if (eachStage.references.length > 0) {
              for (let k = 0; k < eachStage.references.length; k++) {
                let eachStageReference = eachStage.references[k];
                let eachStageReferencePayload = {
                  contentId: eachStageReference.id,
                  organizationId: eachStage.organizationId,
                  initiativeId: eachStage.initiativeId,
                  activityId: eachStage._id,
                };
                let result = await contentInitiativeService.patch(
                  eachStageReferencePayload,
                  eachStage
                );
              }
            }
          }
        }
      }
    },
    async updatePlaybookRefContent(payload, state) {
      try {
        let findIndex = payload.content.playbookActivitiesRef.findIndex(
          (x) => x.activityId == payload.activity._id
        );
        payload.content.playbookActivitiesRef.splice(findIndex, 1);
        await contentService.patch(payload.content._id, payload.content);
      } catch (error) {
        console.log("Error in updatePlaybookRefContent ", error);
      }
    },
  },
};
